"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationMessage = exports.Conversation = exports.TwilioMessage = exports.TwilioConversation = exports.ConversationUser = exports.ConversationParticipant = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const luxon_1 = require("luxon");
const status_1 = require("./status");
class ConversationParticipant extends toccata_1.Model {
}
ConversationParticipant.defaults = {
    attributes: "{}",
};
__decorate([
    toccata_1.validator.IsString()
], ConversationParticipant.prototype, "accountSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationParticipant.prototype, "attributes", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationParticipant.prototype, "conversationSid", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ConversationParticipant.prototype, "dateCreated", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ConversationParticipant.prototype, "dateUpdated", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], ConversationParticipant.prototype, "identity", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], ConversationParticipant.prototype, "lastReadMessageIndex", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], ConversationParticipant.prototype, "lastReadTimestamp", void 0);
exports.ConversationParticipant = ConversationParticipant;
class ConversationUser extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], ConversationUser.prototype, "uid", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationUser.prototype, "displayName", void 0);
__decorate([
    toccata_1.validator.IsPhoneNumber()
], ConversationUser.prototype, "phoneNumber", void 0);
exports.ConversationUser = ConversationUser;
class TwilioConversation extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], TwilioConversation.prototype, "accountSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioConversation.prototype, "attributes", void 0);
__decorate([
    toccata_1.validator.IsObject(),
    toccata_1.validator.IsOptional()
], TwilioConversation.prototype, "bindings", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioConversation.prototype, "chatServiceSid", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], TwilioConversation.prototype, "dateCreated", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], TwilioConversation.prototype, "dateUpdated", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], TwilioConversation.prototype, "friendlyName", void 0);
exports.TwilioConversation = TwilioConversation;
class TwilioMessage extends toccata_1.Model {
}
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "accountSid", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], TwilioMessage.prototype, "attributes", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "author", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "body", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "conversationSid", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], TwilioMessage.prototype, "dateCreated", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], TwilioMessage.prototype, "dateUpdated", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], TwilioMessage.prototype, "delivery", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], TwilioMessage.prototype, "index", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], TwilioMessage.prototype, "links", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], TwilioMessage.prototype, "media", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], TwilioMessage.prototype, "participantSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "sid", void 0);
__decorate([
    toccata_1.validator.IsString()
], TwilioMessage.prototype, "url", void 0);
exports.TwilioMessage = TwilioMessage;
class Conversation extends toccata_1.Model {
}
Conversation.defaults = {
    createdAt: luxon_1.DateTime.utc(),
    updatedAt: luxon_1.DateTime.utc(),
    messages: 0,
    readCount: 0,
    metadata: {},
};
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsString()
], Conversation.prototype, "artistGroupId", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], Conversation.prototype, "messages", void 0);
__decorate([
    toccata_1.validator.IsNumber()
], Conversation.prototype, "readCount", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Conversation.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Conversation.prototype, "updatedAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ConversationUser)
], Conversation.prototype, "user", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(TwilioConversation),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "conversation", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(ConversationParticipant),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "participant", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "participantSid", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "conversationSid", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "lastMessage", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], Conversation.prototype, "lastRead", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], Conversation.prototype, "metadata", void 0);
exports.Conversation = Conversation;
class ConversationMessage extends toccata_1.Model {
}
ConversationMessage.defaults = {
    createdAt: luxon_1.DateTime.utc(),
    updatedAt: luxon_1.DateTime.utc(),
};
__decorate([
    toccata_1.validator.IsString()
], ConversationMessage.prototype, "author", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ConversationMessage.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ConversationMessage.prototype, "updatedAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "displayName", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationMessage.prototype, "message", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "participantSid", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationMessage.prototype, "source", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsIn(status_1.PhoneStatuses)
], ConversationMessage.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsString()
], ConversationMessage.prototype, "uid", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "attributes", void 0);
__decorate([
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "metadata", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)(),
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "sentAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "sid", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(TwilioMessage),
    toccata_1.validator.IsOptional()
], ConversationMessage.prototype, "data", void 0);
exports.ConversationMessage = ConversationMessage;
//export const
//# sourceMappingURL=conversations.js.map